import { atom } from 'recoil';

export const currentPositionAtom = atom({
  key: 'currentPosition',
  default: {
    x: -3041235.262,
    y: 4053908.684,
    z: 3859931.002,
  },
});

export const referencePositionAtom = atom({
  key: 'referencePosition',
  default: {
    x: 0,
    y: 0,
    z: 0,
  },
});

export const deviationAtom = atom({
  key: 'deviation',
  default: {
    e: 0,
    n: 0,
    v: 0,
  },
});

export const zoomLevelAtom = atom({
  key: 'zoomLevel',
  default: 100, // Default zoom level 100m to 1cm
});
